<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card>
          <b-row>
            <b-col sm="12">

              <b-row>
                <b-col sm="4">
                  <span class="pr-"><strong>총 {{items.length}}건</strong></span>
                  <b-button size="sm" variant="success" v-on:click="excelDownloadForm()" class="exceldown_button"><h5 style="margin-bottom:0px"><i class="fa fa-file-excel-o"></i> 엑셀다운로드</h5></b-button>
                  <span style="color:#8c8872; font-weight:bold; font-size:15px">* 아래 정보를 다운받으실수 있습니다.</span>
                </b-col>
                <b-col sm="3"></b-col>
                <b-col sm="3"></b-col>
                <b-col md="2" class="my-1">
                  <b-row>
                    <b-col sm="6">
                      <b-button size="sm" variant="danger" v-on:click="deleteManager()">
                        <h5 style="margin-bottom:0px">
                          <i class="fa fa-remove"></i> 삭제
                        </h5>
                      </b-button>
                    </b-col>
                    <b-col sm="6">
                      <b-form-select v-model="perPage" :options="pageOptions"/>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

            </b-col>


            <b-col v-if="isLoading" sm="12">
              <div class="text-center loadingbar" style="margin:300px 0 350px 0">
                <div style="width:200px; margin:0 auto; vertical-align:middle">
                  <b-spinner label="Large Spinner" style="vertical-align:middle"></b-spinner>
                  <span style="vertical-align:middle; padding:5px; font-weight:blod; font-size:20px">Loading...</span>
                </div>
              </div>
            </b-col>

            <b-col v-else sm="12" class="pt-sm-1">
              <b-row>
                <b-col sm="12">
                  <b-table striped hover :fields="fields" :items="items" :busy="items == 0" :current-page="currentPage" :per-page="perPage">
                    <template slot="선택" slot-scope="row" v-if="row.item.authority != 'MNGR_ATHRT_1'">
                      <b-form-checkbox
                        v-model="row.item.check"
                        value="Y"
                        checked-value="Y"
                        unchecked-value="N"
                      ></b-form-checkbox>
                    </template>

                    <template slot="manager_id" slot-scope="row">
                        <a href="javascript:void(0)" v-on:click="editManager(row.item,'edit')">{{row.item.manager_id}}</a>
                    </template>

                  </b-table>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="11"></b-col>
            <b-col sm="1" class="d-flex justify-content-end">
              <b-button variant="primary" v-on:click="editManager(null, 'new')">신규등록</b-button>
            </b-col>
          </b-row>

          <b-row class="pt-sm-1">
            <b-col sm="12" class="my-1">
              <b-pagination v-model="currentPage" :total-rows="items.length" :per-page="perPage" align="center"/>
            </b-col>
          </b-row>


        </b-card>
      </b-col>
    </b-row>
    <b-modal title="관리자 정보" size="lg" v-model="formModal" @ok="formModal = false"
             no-close-on-backdrop no-close-on-esc hide-footer>
      <managerFormModal v-bind:reportManager="reportManager" v-bind:newFlag="newFlag" ref="managerFormModalRef"></managerFormModal>
      <hr />
      <span class="float-right" style="padding-right:20px;">
        <b-button variant="outline-primary" @click="managerSave()">
          <template v-if="this.newFlag=='new'">
            등록
          </template>
          <template v-else>
            저장
          </template>

        </b-button>
        <b-button variant="outline-success" @click="formModal = false">취소</b-button>
      </span>
    </b-modal>
  </div>
</template>
<script>

import cSwitch from '../../../../components/Switch';
import managerFormModal from './ManagerFormModal';
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { EventBus } from "../../../event-bus";
import swal from "sweetalert2";
const moment = require("moment");

export default {
  name: 'ManagerList',
  props: {
    queryParams: {
      type: Object
    },
    fields: {
      type: Array
    },
    fullDate: {
      type: Array
    },
  },

  components: {
    PulseLoader,
    managerFormModal,
    cSwitch,
  },
  created() {
    // 이벤트 버스 선언
    EventBus.$on("callFindManager", () => {
      this.findManager();
    });
  },
  data () {
    return {
      drDeleteRows: [],
      selectSlotNumbers: [],
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 30, 50, 100],
      selectAll: false,
      items: [],
      excelTotalCnt: 0,
      isLoading: true,

      formModal:false, // 관리자 폼 모달

      reportManager: {
      }, //

      reportManagerForm:{
        manager_id : null,
        password : null,
        password2 : null,
        mobile: '',
        name : null,
        role : 'ROLE_ADMIN',
        authority : 'MNGR_ATHRT_3',
        department : null,
        email : null,
        status : 'MNGR_STATUS_1',
        reg_date : null,
        access_menu: '',
      },
      newFlag:'new', // 신규/수정 구분 플레그
      allStatus: 'MNGR_STATUS_1' // 일괄 계정 허용/만료 상태
    }
  },
  mounted() {
    this.findManager();
  },
  methods: {

    allManagerStatusChange(){
      var list = [];
      for(var i=0; i <this.items.length; i++){
        if(this.items[i].authority == 'MNGR_ATHRT_3'){
          if(this.items[i].check == 'Y'){
            this.items[i].status = this.allStatus;
            list.push(this.items[i]);
          }
        }
      }

      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(list));
      var data = new FormData();
      data.append('objs', param);
      this.$http.post('/api/update/reportManagerListStauts?access_token='+token, data, null)
        .then((result) => {
          this.findManager();
          swal.fire({
            type: 'success',
            title: '관리자 정보를 변경하였습니다.',
            showConfirmButton: false,
            timer: 1500
          })
          this.formModal = false;
        })
    },
    selectAllCheck(){
      for(var i=0; i <this.items.length; i++){
        if(this.items[i].authority != 'MNGR_ATHRT_1'){
          if(this.items[i].check == 'N' || this.items[i].check == null){
            this.items[i].check = 'Y';
          }else{
            this.items[i].check = 'N';
          }
        }
      }
    },

    editManager(manager, status){

      if(status == 'new'){
        this.newFlag = 'new';
        this.reportManager = this.$_.clone(this.reportManagerForm);

      }else if(status == 'edit'){
        this.newFlag = 'edit';
        if (manager.access_menu == null){
          manager.access_menu = '';
        }
        if (manager.mobile == null){
          manager.mobile = '';
        }
        
        this.reportManager = this.$_.clone(manager);
        this.reportManager.password = '';
        this.reportManager.password2 = '';
      }

      this.reportManager.password2 = this.reportManager.password

      if (this.reportManager.access_menu != null){
        this.reportManager.access_menu = this.reportManager.access_menu.split(',');
      } else {
        this.reportManager.access_menu = '';
      }
      this.formModal=true;
    },

    managerSave(){
      this.$refs.managerFormModalRef.validateCheckFN();
      var self = this;

      setTimeout(function(){
        // alert('수정 모드 이벤트 시작');

        if (self.reportManager.mobile == ''){
          swal.fire({
            type: 'warning',
            title: '핸드폰 번호를 입력해주세요.',
            showConfirmButton: false,
            timer: 1500
          })
          return
        } else if (self.reportManager.mobile.includes('-')) {
          swal.fire({
            type: 'warning',
            title: '핸드폰 번호에는 "-"을 포함할 수 없습니다.',
            showConfirmButton: false,
            timer: 1500
          })
          return
        }

        // 유효성 검사 실패 시
        if (!self.reportManager.formValidation) {
          return;
        }

        // 전송용 데이터 복사 (UI에 영향을 주지 않기 위해 clone 사용)
        var submitData = self.$_.clone(self.reportManager);

        // 접근권한 배열 -> 문자열 변환
        if (submitData.access_menu && submitData.access_menu.length > 0 && Array.isArray(submitData.access_menu)){
          submitData.access_menu = submitData.access_menu.join(',');
        } else {
          submitData.access_menu = '';
        }

        var token = sessionStorage.getItem("myToken");

        if(self.newFlag == 'new'){
          submitData.reg_date = moment().format('YYYY-MM-DD HH:mm:ss');

          var param = encodeURI(JSON.stringify(submitData));
          var data = new FormData();
          data.append('objs', param);

          // 신규 관리자 저장
          self.$http.post('/api/insert/reportManager?access_token='+token, data, null)
            .then((result) => {
              self.findManager();
              swal.fire({
                type: 'success',
                title: '신규 관리자를 등록하였습니다.',
                showConfirmButton: false,
                timer: 1500
              })
              self.formModal = false;
            })
        } else if(self.newFlag == 'edit'){
          // alert('수정 모드');

          var param = encodeURI(JSON.stringify(submitData));
          var data = new FormData();
          data.append('objs', param);

          // 기존 관리자 정보 변경
          self.$http.post('/api/update/reportManager?access_token='+token, data, null)
            .then((result) => {
              console.log(result);
              if(result.data.success == true){
                self.findManager();
                swal.fire({
                  type: 'success',
                title: '관리자 정보를 변경하였습니다.',
                showConfirmButton: false,
                timer: 1500
              }).then(function() {
                location.reload();
              })
              self.formModal = false;
              }else{
                swal.fire({
                  type: 'error',
                  title: result.data.message,
                  showConfirmButton: false,
                  timer: 1500
                })
              }
              
            })
        }
      }, 500);
    },

    findManager(){
      var token = sessionStorage.getItem("myToken");

      this.queryParams.start_date = this.$parent.getFormatDate(this.fullDate[0]);
      this.queryParams.end_date = this.$parent.getFormatDate(this.fullDate[1]);

      var param = encodeURI(JSON.stringify(this.queryParams));
      var data = new FormData();
      data.append('objs', param);
      this.$http.post('/api/select/reportManagerList?access_token='+token, data, null)
        .then((result) => {
          this.isLoading = false;
          this.items = result.data;
          this.totalRows = this.items.length;
        })
    },



    deleteManager(manager){

      swal.fire({
        title: '매니저 삭제!',
        text: "선택하신 매니저를 삭제하시겠습니까?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((swalResult) => {
        if (swalResult.value) {


          var self = this;
          this.items.forEach(function (el, idx, arr){
            if(el.check == 'Y'){
              self.drDeleteRows.push(el.manager_id);
            }
          });

          var token = sessionStorage.getItem("myToken");
          var param = encodeURI(JSON.stringify(this.drDeleteRows));
          console.log('param >>>>',param);
          var data = new FormData();
          data.append('managerArr', param);
          this.$http.post('/api/delete/reportManager?access_token='+token, data, null)
            .then((result) => {
              this.findManager();
              swal.fire({
                type: 'success',
                title: '관리자 정보를 변경하였습니다.',
                showConfirmButton: false,
                timer: 1500
              })
              this.formModal = false;
            })
        }
      })
    },



    excelDownloadForm(){
      var self = this;

      if (self.isLoading){
        swal.fire('아직 데이터를 불러오지 못했습니다.', '', 'warning').then(function() {
        });
        return;
      }

      var authKeyTable = "";
      authKeyTable += '<section class="container_login loginbox" style="margin:0px auto">';
      authKeyTable += '    <dl style="margin-top:32px">';
      authKeyTable += '        <dd>';
      authKeyTable += '            <p style="text-align:center; font-weight:600; font-size:17px">현재 아래의 기준으로 다운로드 됩니다.</p>';
      authKeyTable += '            <p style="text-align:center; font-weight:600; font-size:20px; color:#ff6863">';
      authKeyTable += '             현재 데이터수 : <span style="color:#ea0000; font-weight:bold">'+Number(self.items.length).toLocaleString()+'</span>';
      authKeyTable += '            </p>';
      authKeyTable += '        </dd>';
      authKeyTable += '    </dl>';
      authKeyTable += '</section>';

      swal.fire({
        title: '엑셀다운로드!',
        // text: "기본정보 이외에 작성한 데이터는 모두 초기화 됩니다. "+messageValue+"로 변경하시겠습니까?",
        html: authKeyTable,
        type: 'warning',
        showConfirmButton: true,
        // onOpen: function (){
        //
        // },
        confirmButtonColor: '#ff500f',
        confirmButtonText: 'DOWNLOAD',
        onBeforeOpen: () => {
          const content = swal.getContent()
          const $ = content.querySelector.bind(content)
        },
      }).then((swalResult) => {
        if (swalResult.value) {
          // console.log(self.userkeyParams);
          var resultTable = "";
          resultTable += '<table class="r-point" cellspacing="0" style="margin-top: 15px">';
          resultTable += '  <tr>';
          resultTable += '    <th width="120">총 데이터수</th>';
          resultTable += '    <td>'+Number(self.items.length).toLocaleString()+'</td>';
          resultTable += '  </tr>';
          resultTable += '  <tr>';
          resultTable += '    <th>파일 형식</th>';
          resultTable += '    <td>.xlsx</td>';
          resultTable += '  </tr>';
          resultTable += '</table>';

          swal.fire({
            // type: 'success',
            title: '다운로드 중 ..',
            html: resultTable,
            showConfirmButton: false,
            allowOutsideClick: false,
            // timer: 2000,
            onOpen: function (){
              swal.showLoading();
              var filenames = '관리자 리스트.xlsx';

              var token = sessionStorage.getItem("myToken");
              var param = encodeURI(JSON.stringify(self.queryParams));
              var datas = new FormData();
              datas.append('objs', param);
              self.$http.post('/api/excel/managerDownload?access_token=' + token, datas, { responseType: 'blob'})
                .then((result) => {
                  var blob = result.data;
                  if(navigator.appVersion.toString().indexOf('.NET') > 0){ //For IE
                    window.navigator.msSaveOrOpenBlob(blob, filenames);
                  }else if(navigator.userAgent.toLowerCase().indexOf('firefox') >-1){
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = filenames;
                    document.body.appendChild(link);//For FireFox <a> tag event
                    //not working
                    link.click();
                  }else{
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = filenames;
                    link.click();
                  }
                  swal.close();
                })
            },
          }).then(function() {
            swal.fire(
              '다운로드 완료',
              '',
              'success'
            ).then(function() {

            });
          });
        }
      })
    },





  },
}
</script>
<style scoped>
select.error+.select2-container--bootstrap .select2-selection--single {
  color: #9F3A38 !important;
  background-color: #FFF6F6 !important;
  border-color: #E0B4B4 !important;
}

input.error {
  color: #9F3A38 !important;
  background-color: #FFF6F6 !important;
  border-color: #E0B4B4;
}
</style>



// WEBPACK FOOTER //
// src/views/common/manager/component/ManagerList.vue